document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) menuToggle.addEventListener('click', () => { mobileMenu.hidden = !mobileMenu.hidden; });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const json = root.querySelector('[data-product-variants]');
    if (!form || !json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const submit = form.querySelector('[data-product-submit]');
    const optionGroups = Array.from(form.querySelectorAll('[data-option-index]'));
    const formatMoney = (cents) => {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, {style:'currency', currency}).format(cents / 100); }
      catch(e) { return '$' + (cents / 100).toFixed(2); }
    };
    const update = () => {
      const selected = optionGroups.map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : '';
      });
      const match = variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = 'UNAVAILABLE'; }
        return;
      }
      idInput.value = match.id;
      // Change the lead product photo when a selected variant has its own image.
      const variantImage = match.featured_image && (match.featured_image.src || match.featured_image);
      const leadImage = root.querySelector('.product-media-item img');
      if (variantImage && leadImage) {
        const nextSrc = typeof variantImage === 'string' ? variantImage : '';
        if (nextSrc) { leadImage.src = nextSrc; leadImage.srcset = ''; }
      }
      if (priceEl) priceEl.innerHTML = formatMoney(match.price) + (match.compare_at_price > match.price ? ' <s>' + formatMoney(match.compare_at_price) + '</s>' : '');
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
      optionGroups.forEach((group, index) => {
        group.querySelectorAll('input').forEach((input) => {
          const candidate = selected.slice();
          candidate[index] = input.value;
          input.disabled = !variants.some((variant) => variant.available && variant.options.every((value, i) => i === index ? value === input.value : value === candidate[i]));
        });
      });
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    };
    optionGroups.forEach((group) => group.addEventListener('change', update));
    update();
  });

  document.querySelectorAll('[data-quick-add]').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      const form = button.closest('form');
      if (!form) return;
      button.disabled = true;
      const original = button.innerHTML;
      button.innerHTML = 'ADDING...';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Add to cart failed');
        const item = await response.json();
        const countResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await countResponse.json();
        document.querySelectorAll('.cart-count').forEach((el) => el.textContent = cart.item_count);
        const toast = document.querySelector('[data-cart-toast]');
        if (toast) { toast.textContent = `${item.product_title || 'Product'} added to your bag.`; toast.classList.add('is-visible'); window.setTimeout(() => toast.classList.remove('is-visible'), 2600); }
        button.innerHTML = 'ADDED ✓';
        window.setTimeout(() => button.innerHTML = original, 1500);
      } catch (error) { form.submit(); }
      finally { window.setTimeout(() => button.disabled = false, 700); }
    });
  });
});